import React from 'react';

const SrLeaseDraftCheckbox = () => (
  <img
    style={{ position: 'relative', top: '4px', marginRight: '2px' }}
    alt='checkbox'
    src='/images/checkbox-checked-lease-draft.png'
  />
);

SrLeaseDraftCheckbox.displayName = 'SrLeaseDraftCheckbox';

export default SrLeaseDraftCheckbox;
